import { Box } from "@mui/material";
import { useParams } from 'react-router-dom';
import { ProjectConfiguration } from "components/global/reportLayout/ProjectConfiguration";
import { ProjectReportPreview } from "components/global/reportLayout/ProjectReportPreview";
import { useState, useEffect } from "react";
import { useAPI } from 'components/lib';
import { LoadingBackdrop } from "components/global/LoadingBackdrop/LoadingBackdrop";
import chaptersData from "./Chapters.json";
import { APIKeyModal } from "components/global/reportLayout/ConfigurationComponent/APIKeyModal";

export function UserLabReport() {
    const { lab_id } = useParams();
    const { data, loading } = useAPI(`/lab/${lab_id}/report`, 'GET');
    const [basicInfo, setBasicInfo] = useState({
        title: "",
        student: "",
        regNo: "",
        instructor: "",
        institution: "",
        course: "",
        projectType: "",
        technologies: "",
        keywords: "",
        abstract: "",
        acknowledgements: ""
    });

    const [apiKey, setApiKey] = useState("");
    const [chapters, setChapters] = useState([]);
    const [apiManageDialog, setApiManageDialog] = useState(false);
    const [references, setReferences] = useState([]);

    useEffect(() => {
        if (data) {
            setBasicInfo((prev) => ({
                ...prev,
                title: data?.labData?.name || prev.title
            }));

            if (data?.apiKey) {
                setApiKey(data.apiKey);
                sessionStorage.setItem("apiKey", data.apiKey);
            } else {
                const storedKey = sessionStorage.getItem("apiKey");
                if (storedKey) {
                    setApiKey(storedKey);
                }
            }
        }
    }, [data]);

    useEffect(() => {
        if (chapters.length === 0) {
            const chaptersFields = chaptersData.chapters;
            setChapters(
                chaptersFields.map((ch) => ({
                    ...ch,
                    content: "",
                    sections: ch.sections.map((sec) => ({ ...sec, content: "" }))
                }))
            );
        }
    }, [chaptersData]);

    return (
        <>
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : (
                < Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: '100vh',
                    background: '#f6f8fc',
                    boxSizing: 'border-box',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: 4,
                }}>
                    <Box sx={{
                        flex: '1 1 0',
                        maxWidth: '50%',
                        minWidth: 380,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 2,
                        p: 3,
                        mr: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        height: `800px`,
                        overflow: 'hidden',
                    }}>
                        <Box sx={{ flex: 1, overflow: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
                            <ProjectConfiguration
                                basicInfo={basicInfo}
                                setBasicInfo={setBasicInfo}
                                chapters={chapters}
                                setChapters={setChapters}
                                references={references}
                                setReferences={setReferences}
                                apiKey={apiKey}
                                setApiManageDialog={setApiManageDialog}
                            />
                        </Box>
                    </Box>

                    <Box sx={{
                        flex: '1 1 0',
                        minWidth: '50%',
                        maxWidth: 600,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 2,
                        p: 3,
                        ml: 0,
                        overflow: 'hidden',
                        height: `800px`,
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Box sx={{
                            flex: 1,
                            overflowY: 'auto',
                            scrollbarWidth: 'thin',
                            WebkitOverflowScrolling: 'touch',
                        }}>
                            <ProjectReportPreview
                                basicInfo={basicInfo}
                                chapters={chapters}
                                references={references}
                            />
                        </Box>
                    </Box>
                    <APIKeyModal
                        open={apiManageDialog}
                        apiKey={apiKey}
                        setApiKey={setApiKey}
                        onClose={() => setApiManageDialog(false)}
                    />
                </Box >
            )}
        </>
    );
}